var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobeicon = function SvgGlobeicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.2C6.035 1.2 1.2 6.035 1.2 12c0 5.964 4.835 10.8 10.8 10.8 5.965 0 10.8-4.836 10.8-10.8 0-5.965-4.835-10.8-10.8-10.8Zm8.304 9.6H17.22a16.943 16.943 0 0 0-1.416-6.277 8.4 8.4 0 0 1 4.5 6.276ZM12 20.4h.54c1.092-.708 2.352-3.336 2.568-7.2H8.892c.168 3.888 1.476 6.516 2.568 7.2H12Zm-3.06-9.6c.216-3.864 1.476-6.492 2.568-7.2h1.032c1.092.684 2.4 3.312 2.568 7.2H8.94Zm-2.16 0a16.944 16.944 0 0 1 1.416-6.277 8.4 8.4 0 0 0-4.5 6.276H6.78Zm-3.084 2.4H6.78a16.944 16.944 0 0 0 1.416 6.276 8.4 8.4 0 0 1-4.5-6.276Zm13.524 0a16.943 16.943 0 0 1-1.416 6.276 8.4 8.4 0 0 0 4.5-6.276H17.22Z",
    clipRule: "evenodd"
  })));
};
export default SvgGlobeicon;